
































































































































import { Vue } from 'vue-property-decorator';
import Component from 'vue-class-component';

import basketService from '@/project/basket/basket.service';
import clearBasketOverlayService from '@/project/modals/overlays/ClearBasketOverlay.service';
import authService from '@/core/auth/auth.service';

import { BasketQuoteViewObject, BasketViewModel, ItemIdWithCount, LineItemViewObject } from '@/types/apiServerContract';
import BasketLineItem from './BasketLineItem.vue';
import PageToaster from '@/project/ui-components/PageToaster.vue';
import BasketPageTracker from '@/project/tracking/gtm/BasketPageTracker.vue';
import { PageName } from '@/router/routes/constants';
import OrderSummary from '@/project/ui-components/order/OrderSummary.vue';
import SpinnerOverlay from '@/project/spinners/SpinnerOverlay.vue';
import BasketQuote from './BasketQuote.vue';
import addMultipleItemsToBasketOverlayService from '@/project/modals/overlays/AddMultipleItemsToBasketOverlay.service';
import AdnuntiusBasketBannerBlock from '@/project/app/blocks/AdnuntiusBasketBannerBlock.vue';
import BasketFavorite from '@/project/app/client-pages/basket-page/BasketFavorite.vue';
import scrollService from '@/core/scroll/scroll.service';
import { ValidationObserver } from 'vee-validate';

@Component({
    components: {
        BasketPageTracker,
        BasketLineItem,
        PageToaster,
        OrderSummary,
        SpinnerOverlay,
        BasketQuote,
        AdnuntiusBasketBannerBlock,
        BasketFavorite
    }
})

export default class BasketPage extends Vue {
    private priceNotAvailable: boolean = false;
    private invalidOrNotFoundItems: ItemIdWithCount[] = [];

    $refs!: {
        observerRef: InstanceType<typeof ValidationObserver>,
        basketPageTracker: BasketPageTracker

    }

    private get isBasketInitialized() {
        return basketService.isBasketLoaded;
    }

    private clearBasket() {
        clearBasketOverlayService.show();
    }

    private get checkoutPage() {
        return PageName.CHECKOUT;
    }

    private gotoCheckout() {
        this.$router.push({ name: this.checkoutPage });
    }

    private async addMultipleItems() {
        const notFoundItems = await addMultipleItemsToBasketOverlayService.show();
        this.invalidOrNotFoundItems = notFoundItems ?? [];
    }

    private get basket(): BasketViewModel | null {
        return basketService.basketWithCommittedLineItems;
    }

    private get lineItems(): LineItemViewObject[] {
        return this.basket?.lineItems ?? [];
    }

    private get quotes(): BasketQuoteViewObject[] {
        return this.basket?.quotes ?? [];
    }

    private get hasItemsInbasket() {
        return this.lineItems.length > 0 || this.quotes.length > 0;
    }

    get isUserLoggedIn(): boolean {
        return authService.isLoggedIn();
    }

    private async created() {
        await basketService.recalcBasket();
    }

    private isEqual(a: any, b: any): boolean {
        return JSON.stringify(a) === JSON.stringify(b);
    }

    private scrollToFirstError() {
        this.$refs.observerRef.validate().then(() => {
            const errorChild = this.$refs.observerRef.$children.length && (this.$refs.observerRef.$children[0] as InstanceType<typeof ValidationObserver>);
            if (errorChild) {
                const firstErrorFieldName = Object.keys(errorChild.errors).find((item) => {
                    return errorChild.errors[item].length > 0 ? item : false;
                });

                const firstField = document.querySelector(`[name="${firstErrorFieldName}"]`);
                if (firstField) {
                    scrollService.scrollToElement(((firstField.parentElement) || firstField) as HTMLElement, -100);
                }
            }
        });
    }
}
